module.exports = __webpack_public_path__ + "img/julian.e29d4dcc.svg";